import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import AdminHeader from './AdminHeader';

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <div className="h-screen flex bg-white dark:bg-slate-900">
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />

      <div className="flex-1 flex flex-col overflow-hidden">
        <AdminHeader onMenuClick={toggleSidebar} />

        <main className="flex-1 overflow-y-auto bg-gray-50 dark:bg-slate-800 p-4 sm:p-6 lg:p-8 pb-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
